import Vue from 'vue'
import store from '@/store'
import router from '@/router'
import api from '@/api'
import tripurx from '@/utils/common'
import eventBus from '@/eventbus'
import App from '@/App'
import VueClipboard from 'vue-clipboard2'

import '@/plugins'
import '@/directives'
import '@/mixins'
import '@/assets/styles/app.less'

Vue.use(api).use(tripurx).use(eventBus).use(VueClipboard)

Vue.config.productionTip = false
// Vue.config.devtools = true

new Vue({
  store,
  router,
  eventBus,
  render: h => h(App)
}).$mount('#app')
